(function () {
    'use strict';

    angular
        .module('app.surveys')
        .run(appRun);

    appRun.$inject = ['routerHelper', 'opsIncludeVersion'];
    /* @ngInject */
    function appRun(routerHelper, opsIncludeVersion) {
        routerHelper.configureStates(getStates(opsIncludeVersion));
    }

    function getStates(opsIncludeVersion) {
        return [
              {
                  state: 'surveys',
                  config: {
                      abstract: true,
                      url: '/surveys',
                      template: '<ui-view/>',
                      settings: {
                          authMode: 1
                      },
                      resolve: {
                          authenticationRequired: ['userService', function (userService) {
                              if (userService.tenantId() != "1") {
                                  throw { name: "NotAdmin" };
                              }
                          }]
                      }
                  }
              },
            {
                state: 'surveys.list',
                config: {
                    url: '/surveylist',
                    templateUrl: 'app/surveys/list.html?v=' + opsIncludeVersion,
                    controller: 'SurveyListController',
                    controllerAs: 'vm',
                    title: 'Questions'
                }
            },
            {
             state: 'surveys.details',
             config: {
                 url: '/survey/:id',
                 templateUrl: 'app/surveys/details.html?v=' + opsIncludeVersion,
                 controller: 'SurveyDetailsController',
                 controllerAs: 'vm',
                 title: 'Survey Details',
                 settings: {}
             }
            },
            {
                state: 'surveys.results',
                config: {
                    url: '/surveyresult/:id',
                    templateUrl: 'app/surveys/results.html?v=' + opsIncludeVersion,
                    controller: 'SurveyResultsController',
                    controllerAs: 'vm',
                    title: 'Survey Results',
                    settings: {}
                }
            }
          
        ];
    }
})();
